import { Subscription } from 'rxjs';
import { distinctUntilChanged, filter, take } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, OnDestroy } from '@angular/core';
import { VersionNumber } from 'src/app/view/help/services/models/versionInfo.data';
import { ContextDataService } from 'src/app/view/user-context/services/context.data-service';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ClientVersionService implements OnDestroy {
  private subscription?: Subscription;

  constructor(
    private ctxDS: ContextDataService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  initialize(): void {
    if (this.subscription) return;
    this.subscription = this.ctxDS.version$
      .pipe(
        distinctUntilChanged(),
        filter(
          (version) =>
            typeof version === 'string' &&
            version !== '0.0.0' &&
            VersionNumber.compare(version, environment.version as VersionNumber) > 0
        ),
        filter((version) => this.recordRefreshAttempt(version)),
        take(1)
      )
      .subscribe(() => this.document.defaultView?.location.reload());
  }

  private recordRefreshAttempt(requiredVersion: VersionNumber): boolean {
    const browser = this.document.defaultView;
    if (!browser) return false;
    const key = `fliko.clientRefresh.${environment.version}`;
    try {
      if (browser.sessionStorage.getItem(key) === requiredVersion) return false;
      browser.sessionStorage.setItem(key, requiredVersion);
      return true;
    } catch (error) {
      console.warn('Client refresh could not be recorded', error);
      return false;
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
